export default "__VITE_ASSET__Dtmu48qf__"